import React from "react";

//CSS
import "../../../utils/Css/Marketing.css";
import "../../../utils/Css/Campagne.css";

//Link
import { Link } from "react-router-dom";



function ListeOffres() {
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {/* <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-solid fa-percent icon-campagne mr-3"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Promotions</span>
                  <span className="info-box-number"><Link to={"/discount"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>
            </div> */}
            <div className="col-lg-3 col-4">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-solid fa-box icon-campagne mr-3"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Packs</span>
                  <span className="info-box-number"><Link to={"/pack"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-4">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-wand-magic-sparkles"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Avantages Exclusifs
                  </span>
                  <span className="info-box-number"><Link to={"/conditionscommercials"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-4">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-users"></i></span>
                <div className="info-box-content">
                  <span className="info-box-text">Tiers Condition commercial
                  </span>
                  <span className="info-box-number"><Link to={"/conditionscommercialsTiers"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-solid fa-box icon-campagne mr-3"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Abonnements</span>
                  <span className="info-box-number"><Link to={"/abonnements"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>
            </div> */}
            {/* <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-gift"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Cartes Cadeaux</span>
                  <span className="info-box-number"><Link to={"/cartesCadeaux"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>

            </div> */}

            {/* <div className="col-lg-3 col-6">
              <div className="info-box mb-3 bg-gray">
                <span className="info-box-icon"><i class="fas fa-shop"></i>
                </span>
                <div className="info-box-content">
                  <span className="info-box-text">Promo sur caisse</span>
                  <span className="info-box-number"><Link to={"/promoSurCaisse"} style={{ color: "white" }}>Voir plus</Link></span>
                </div>
              </div>

            </div> */}
         
          </div>
        </div>
      </section>
    </div>
  );
}

export default ListeOffres;
